export default "__VITE_ASSET__B3G09smd__"